import Masonry from "./Masonry";
import ResponsiveMasonry from "./ResponsiveMasonry";
export default Masonry;
export { ResponsiveMasonry };


//////////////////
// WEBPACK FOOTER
// ./~/react-responsive-masonry/es/index.js
// module id = 9053
// module chunks = 2